import React, { useContext } from 'react';
import '../styles/basketItemDiscount.css';
import '../styles/summary.css';
import { LanguageContext } from '../context/language/LanguageContext';
import appConst from '../Utilities/appConst.json';
import { useSelector } from 'react-redux';
import { resolveShippingTitle } from '../Utilities/shippingTitle';

export default function SummaryShipping(props) {
    const languageContext = useContext(LanguageContext);
    const selectedShippingMethod = useSelector(
      (state) => state.shipping.selectedShippingMethod
    );
    const shippingMethodLabel = languageContext.getTranslation(
      appConst.SHIPPING_METHOD
    );
    const shippingMethodTitle = resolveShippingTitle({
      id: selectedShippingMethod?.id,
      getTranslation: (key) => languageContext.getTranslation(key),
      fallbackTitle: props.shippingMethod || selectedShippingMethod?.displayName || "",
    });

    return (
        <div className="summary_shipping summary_container" data-testid="summary-shipping">
            <div className="summary_box_item" style={{ columnGap: "0.35rem" }}>
                <div className='box_item_r font_bold' data-testid="summary-shipping-label">{shippingMethodLabel}</div>
                <div className='box_item_l' data-testid="summary-shipping-method">{shippingMethodTitle}</div>
            </div>
            <div className='box_item_l' data-testid="summary-shipping-price">₪{parseFloat(props.shippingPrice).toFixed(2)}</div>
        </div>
    )
}
